import React, { useEffect, useState } from 'react';
import { TiposFuncionAdapter } from '../../../../../infraestructure/persistence/rest/TiposFuncionAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboTiposFuncion from './combo';


export const ComboTiposFuncionContainer = (props: any) => {
  
  const api = new TiposFuncionAdapter();
  let { resultError, exceptionError } = useNotifications();
  let [tiposFuncion, setTiposFuncion] = useState<any>(undefined)
  let result: any;
  
  useEffect(()=>{
    getTiposFuncion();
  },[])

	const getTiposFuncion = async() =>{
    try {
      result = await api.ListarTiposFuncione();
      if(result.data && result.data!=="")
			{
        setTiposFuncion([...result.data] || []);
      }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }

  return <ComboTiposFuncion {...props} options={tiposFuncion}/>
};

export default ComboTiposFuncionContainer;